import DatabaseModel from './DatabaseModel.js';

// #815 · Gasto de IA de la ERP (pantalla de administrador). Solo LECTURA del registro único de
// consumo de simecal-ai (#814), reenviado por movilidad solo para ADMIN. Siempre fresco
// (cached=false): una cifra de gasto cacheada sería la de otro momento.
const GastoIa = Object.create(DatabaseModel);

GastoIa.model = 'ai/consumo';

// `desde` y `hasta` en AAAA-MM-DD, los dos incluidos; sin ellos, el mes en curso.
GastoIa.resumen = function(desde, hasta) {
    const self = this;
    let url = self.server_movilidad + self.prefix + self.model + '/resumen';
    if (desde && hasta) {
        url += '?desde=' + encodeURIComponent(desde) + '&hasta=' + encodeURIComponent(hasta);
    }
    return self.sendRequest({ url: url, method: 'GET', data: {} }, false);
};

export default GastoIa;
